import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//components
import Head from 'components/common/Head/Head';
//styles
import { ErrorContainer, Header, Message, IconWrapper } from '../ErrorPages.styled';
import { DefaultButton } from 'components/styled/Button';
//assets
import errorIllustration from 'assets/illustrations/500.svg';
import { ArrowRightIcon } from 'assets/icons';

export const InternalErrorScreen = () => {
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      <Head title={t('Internal server error')} />
      <img src={errorIllustration} alt="500 Error" />

      <Header>{t('Internal server error')}</Header>
      <Message>
        {t(
          'The server encountered an internal error or misconfiguration and was unable to complete your request',
        )}
      </Message>
      <Link to={'/accommodations/dashboard'}>
        <DefaultButton type="button" color="blue">
          <IconWrapper>
            <ArrowRightIcon rotate={180} stroke="white" />
          </IconWrapper>
          {t('Back to homepage')}
        </DefaultButton>
      </Link>
    </ErrorContainer>
  );
};
